import React from 'react';
import { useCart } from '../../context/CartContext';
import ScenarioCheckoutWrapper from './ScenarioCheckoutWrapper';

function ScenarioCheckoutPage() {
  const { cart, removeFromCart } = useCart();

  return (
    <div>
      <h2>Your Cart</h2>
      {cart.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          {cart.map(item => (
            <div key={item.scenarioId} onClick={() => removeFromCart(item.scenarioId)}>
              {item.scenarioTitle} — by {item.creatorName}
            </div>
          ))}
          <ScenarioCheckoutWrapper />
        </>
      )}
    </div>
  );
}

export default ScenarioCheckoutPage;
